import { render } from "./Download.vue?vue&type=template&id=2f8820a3&scoped=true"
import script from "./Download.vue?vue&type=script&lang=ts"
export * from "./Download.vue?vue&type=script&lang=ts"

import "./Download.vue?vue&type=style&index=0&id=2f8820a3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2f8820a3"

export default script